module.exports = __webpack_public_path__ + "static/hero_visual_back-abff33caf185db2169d2b09ff879a52b.png";